// src/pages/Billing/BillingSuccess.jsx
import React, { useEffect, useState } from "react";
import { Button, Card, Spinner } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getSubscriptionStatus } from "../../lib/subscription";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [checking, setChecking] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState("");

  // not strictly required, but useful for debugging
  const sessionId = searchParams.get("session_id") || "";

  useEffect(() => {
    let cancelled = false;

    const poll = async () => {
      setChecking(true);
      setError("");

      // Poll up to ~15 seconds
      const maxAttempts = 10;
      const delayMs = 1500;

      for (let i = 0; i < maxAttempts; i++) {
        try {
          const res = await getSubscriptionStatus();

          if (cancelled) return;

          if (res?.status === "active") {
            setIsActive(true);
            setChecking(false);
            return;
          }
        } catch (e) {
          // ignore transient errors during polling
          console.warn("Subscription status check failed (poll):", e?.message);
        }

        await new Promise((r) => setTimeout(r, delayMs));
      }

      if (!cancelled) {
        setChecking(false);
        setIsActive(false);
        setError(
          "Your payment went through, but activation is still processing. If it doesn’t unlock in a minute, return to your profile or contact support."
        );
      }
    };

    poll();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="d-flex justify-content-center mt-5">
      <Card className="p-4 text-center" style={{ maxWidth: 420, width: "100%" }}>
        <h4 className="mb-2">Thank you! 🎉</h4>

        {checking ? (
          <>
            <p className="text-muted mb-3">
              Activating your subscription now…
            </p>
            <div className="d-flex justify-content-center align-items-center gap-2 mb-2">
              <Spinner animation="border" size="sm" />
              <span className="small text-muted">Checking status</span>
            </div>
            {sessionId && (
              <div className="small text-muted">
                Session: <span style={{ fontFamily: "monospace" }}>{sessionId}</span>
              </div>
            )}
          </>
        ) : isActive ? (
          <p className="text-muted mb-4">
            Your subscription is active. You’re all set.
          </p>
        ) : (
          <>
            <p className="text-muted mb-3">
              Payment successful — activation may take a moment.
            </p>
            {error && <div className="small text-danger mb-2">{error}</div>}
          </>
        )}

        <div className="d-flex justify-content-center gap-2 flex-wrap mt-3">
          <Button className="lpp-pill-btn" onClick={() => navigate("/profile")}>
            Go to my profile
          </Button>

          <Button
            variant="outline-secondary"
            className="lpp-pill-btn-outline"
            onClick={() => navigate("/subscribe")}
          >
            Manage plan
          </Button>
        </div>
      </Card>
    </div>
  );
}
